import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatPoints } from '@/utils/formatPoints';
import styles from './styles.module.scss';

export interface PointsValueProps {
  points: number | string | null | undefined;
  className?: string;
  testId?: string;
}

/** User's score in a tournament: figure + plural-aware uppercase unit ("0 очков", "1 очко"). */
export const PointsValue: React.FC<PointsValueProps> = ({ points, className, testId }) => {
  const { t } = useTranslation('tournament');
  const count = Number(points ?? 0);

  return (
    <span className={[styles.points, className].filter(Boolean).join(' ')} data-testid={testId}>
      <b>{formatPoints(points)}</b>
      <span>{t('tournament:pointsUnit', { count: Number.isFinite(count) ? count : 0 })}</span>
    </span>
  );
};

export default PointsValue;
